import { Pipe, PipeTransform } from '@angular/core';

import { DcTypes, Feature } from '@vi-iot/client';

/**
 * Purpose of this pipe is to easily transform any custom object
 * into an object compatibile with pipes which operate on DC-Features like value2 or unit
 *
 * @usageNotes
 *
 * In the following example, `featureLike` transforms customObject into value2 compatibile object.
 *
 * ```const customObject = {
 *     value: 60,
 *     viewValue: '+KEY.GENERAL.CELCIUS',
 *     measureUnit: 'celsius',
 *     otherIncompatibileKey: true
 * }```
 *
 * `<span>{{ customObject | featureLike: 'value':'measureUnit':'temperature' }}</span>`
 *
 */
@Pipe({
  name: 'featureLike',
})
export class FeatureLikePipe implements PipeTransform {
  transform(
    originalObject: { [key: string]: any },
    value = 'value',
    unit = 'unit',
    property = 'value'
  ): Feature<unknown, never> {
    const objValue = originalObject?.[value];
    const objUnit = originalObject?.[unit];

    const valueProperty = {
      type: DcTypes.number,
      value: objValue,
      unit: objUnit,
    };

    return {
      properties: { [property]: valueProperty },
    } as Feature<unknown, never>;
  }
}
